import { Fragment, type ReactNode } from "react";

import { indent } from "./parseStringWithBrAndNewLine.styles";

const parseToken = (token = ""): ReactNode => {
    if (token === "<br/>") {
        // Return <br/> tag as-is
        return <br />;
    } else if (token.includes("\u2022")) {
        const indexOfBulletPoint = token.indexOf("\u2022");

        // Split the string into two parts, before and after the tab
        const beforeTab = token.slice(0, indexOfBulletPoint);
        const afterTab = token.slice(indexOfBulletPoint + 1);

        return (
            <>
                {beforeTab}
                <div className={indent}>{parseToken(afterTab)}</div>
            </>
        );
    } else {
        // Return text as-is
        return token;
    }
};

/**
 *
 * @param htmlString
 * string containing text <br/> tags, \n or bullet point - \u2022
 *
 * @returns ReactNode
 */
export const parseStringWithBrAndNewLines = (htmlString: string): ReactNode => {
    const replacedNewlines = htmlString.replaceAll("\n", "<br/>");
    const tokens = replacedNewlines.split(/(<\/?[^>]+>)/);

    const children = tokens.map((token, index) => {
        return <Fragment key={index}>{parseToken(token)}</Fragment>;
    });

    return <>{children}</>;
};
